import { render, staticRenderFns } from "./LocalAreaListTabs.vue?vue&type=template&id=2a4b46a5&scoped=true&"
import script from "./LocalAreaListTabs.vue?vue&type=script&lang=js&"
export * from "./LocalAreaListTabs.vue?vue&type=script&lang=js&"
import style0 from "./LocalAreaListTabs.vue?vue&type=style&index=0&id=2a4b46a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b46a5",
  null
  
)

export default component.exports